import { Box, Button, Typography } from "@mui/material";
import { FC, useCallback, useEffect } from "react";
import NavigationNotFound from "../../assets/images/navigation_not_found_1x.png";
import { Colors } from "../../styles/constant";
import { useNavigate } from "react-router-dom";
import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import { updateLoadingState } from "../../features/Feature_Loading/Loading_Slice";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import {
  ONE_LOGIN_DASHBOARD,
  SCREEN_TYPE,
  statusCode,
} from "../../utils/constants";
import { triggerCleverTapEvent } from "../../utils/CleverTap";
import { CleverTapEventType } from "../../utils/CleverTapConstant";
import { CT_ScreenEvntDtls } from "../../features/Feature_CleverTap/ScreenEvents/CleverTapEventDetails";
import { windowOpen } from "../../utils/helper";
import { R_HomeRoutes } from "../../utils/Routes";
import { useLazySaveUiExceptionQuery } from "../../features/Feature_GeneralAppElements/GeneralAppElements_Api";
import { API_STATUS_CODE } from "../../utils/ApiEndpoints";

type NotFoundProps = {
  hideButton?: boolean;
  pageName?: string;
  errorTitle?: string;
  errorMessage?: any;
  moduleName?: string;
};
const NotFound: FC<NotFoundProps> = ({
  hideButton = false,
  moduleName,
  pageName,
  errorTitle,
  errorMessage,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const csAppSlice = useAppSelector((st) => st.CsAppSlice);
  const [saveUIExceptionApi] = useLazySaveUiExceptionQuery();

  useEffect(() => {
    triggerCleverTapEvent(CleverTapEventType.SCREEN_EVENT, {
      ScreenName: CT_ScreenEvntDtls.R_GAE.gaUnableToNavError.screenName,
      ScreenType: SCREEN_TYPE.DashboardScreenType,
    });
    dispatch(updateLoadingState(false));
  }, []);

  const saveUIExceptionApiFun = async () => {
    const payload = {
      module: moduleName ? moduleName : "",
      pageName: pageName ? pageName : "",
      type: "UI",
      httpStatusCode: statusCode,
      httpErrorCode: "error",
      httpErrorMessage: "errorMessage",
      uiDisplayTitle: "Unable to navigate",
      uiDisplayMessage: errorMessage.messages || "Something went wrong!",
      errorStack: errorMessage.stack || "",
      errorStackMessage: errorMessage.message || "Something went wrong!",
    };

    await saveUIExceptionApi(payload).then((res) => {
      if (res.isError || res.data?.code !== API_STATUS_CODE.SUCCESS) {
        console.error("Error sending exception details", res?.error);
      }
    });
  };

  useEffect(() => {
    saveUIExceptionApiFun();
  }, []);

  const gotoHomepage = useCallback(() => {
    if (csAppSlice.channel === E_ChannelOptions.ONE_ABC) {
      windowOpen(ONE_LOGIN_DASHBOARD, "_self");
    } else {
      navigate(R_HomeRoutes.home, { replace: true });
    }
  }, []);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      height="calc(100vh - 200px)"
    >
      <img src={NavigationNotFound} height={"196px"} width={"196px"} />
      <Box marginBlock="2rem" textAlign="center">
        <Typography variant="h3" marginBottom="0.5rem">
          Unable to navigate
        </Typography>
        <Typography variant="h5" color={Colors.textGray}>
          We are facing some technical issue. Please try again after some time 
        </Typography>
      </Box>
      {!hideButton && (
        <Button
          variant="contained"
          sx={{
            padding: "1rem 2rem",
          }}
          onClick={gotoHomepage}
        >
          Go back to homepage
        </Button>
      )}
    </Box>
  );
};
export default NotFound;
